export class BilletCancelationModel {
    reason:string = ''

    constructor(b?:Partial<BilletCancelationModel>) {
        Object.assign(this, b)
    }

    isValid():boolean {
        return !!this.reason
    }
}
